export default function BasketFixedFactory(
    $q,
    houseService,
    BasketFixedStorage,
    moment,
    Log
) {
    var fn = this;

    fn.isPeriodOverdue = (end) => {
        return moment() > moment(end);
    };

    fn.addPeriod = (period, search) => {
        Log.obj("BasketFixed: period added : ", period, "highlight");
        Log.obj("BasketFixed: added from search : ", search);
        // TEST 1 :
        // period = fn.TESTforceBookingToBeOutdated(period);

        // if (fn.isPeriodOverdue(period.end)) {
        //     return $q.reject("period-is-overdue");
        // }

        let basketPeriods = BasketFixedStorage.getBookingsStorage();

        // const dublicates = BasketFixedJar.currentBookings.filter((booking) => {
        //     return booking.Periods[0].UniqueKey == period.UniqueKey;
        // });

        // if (dublicates.length) {
        //     return $q.reject("period-allready-in-basket");
        // }

        // business logic check - popup with user action ( continue or not! );

        // PUT PERIOD IN THE BASKET

        // defaults to true

        // period.BookingStart = moment().add("1", "minutes").format();
        basketPeriods.push(period);
        // Save booking in localstorage
        BasketFixedStorage.setBookingsStorage(basketPeriods);

        return $q.resolve(period);
    };

    return fn;
}
